import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import {isUserAdmin} from '../../../utils/identity-utils'
import {Box, Button} from '@material-ui/core'
import AddIcon from '@mui/icons-material/Add'
import {useStyles} from './add-company-button-styles'
import {AddCompany} from '../add-company'

export function AddCompanyButton()  {
    const [isOpen, setIsOpen] = useState(false);
    const user = useSelector((state: any) => state.user);
    const styles = useStyles();
    const isAdmin = isUserAdmin(user);

    const handleOpenCompany = () => {
        setIsOpen(true);
    };

    const handleCloseCompany = () => {
        setIsOpen(false);
    };

    return (
        <Box className={styles.addCompanyContainer}>
            {isAdmin && (
                <Button
                    variant="outlined"
                    size="medium"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={handleOpenCompany}
                    data-testid="addCompany"
                    className={styles.boxItemEnd}
                >
                    ADD COMPANY
                </Button>
            )}
            <AddCompany open={isOpen} onClose={handleCloseCompany} />
        </Box>
    );
};